import { pathgen } from 'object-path-generator';
export const SuggestedOutputDisplayTestIds = pathgen('SuggestedOutputDisplayTestIds');
